type SaveTranslations = () => Promise<boolean> | undefined;

let pendingSave: SaveTranslations | null = null;

export const registerPendingTranslationSave = (
  save: SaveTranslations | null
): void => {
  pendingSave = save;
};

export const savePendingTranslations = async (): Promise<boolean> =>
  (await pendingSave?.()) ?? true;
